import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action, set } from '@ember/object';
import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';

interface SettingsReportsTablesCellsTdHotelOrMarketSignature {
  Args: {
    cellData: unknown;
  };
}

export default class SettingsReportsTablesCellsTdHotelOrMarket extends Component<SettingsReportsTablesCellsTdHotelOrMarketSignature> {
  isHovered = false;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hotel() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.cellData?.hotel;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get market() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.cellData?.market;
  }

  @action
  // @ts-expect-error: Incorrect type
  isCellHovered(isHovered): void {
    set(this, 'isHovered', isHovered);
  }

  <template>
    <div
      class="hotel-or-market cell-wrapper flex items-center gap-100 truncate"
      role="tooltip"
      {{on "mouseenter" (fn this.isCellHovered true)}}
      {{on "mouseleave" (fn this.isCellHovered false)}}
    >
      {{#if this.hotel}}
        <PrismIcon @name="business-type-hotel" @size="small" />
        <LinkTo @model={{this.hotel.id}} @route="hotel.rates" target="_blank">
          {{this.hotel.hotelinfo.name}}
        </LinkTo>
      {{else if this.market}}
        <PrismIcon @name="business-type-market" @size="small" />
        <LinkTo
          @model={{this.market.id}}
          @route="market.marketrates"
          target="_blank"
        >
          {{this.market.displayName}}
        </LinkTo>
      {{/if}}
    </div>
    {{#if this.isHovered}}
      <EmberTooltip
        @isShown={{this.isHovered}}
        @tooltipClass="default-tooltip default-tooltip--large"
      >
        <div class="flex items-center gap-100">
          {{#if this.hotel}}
            <PrismIcon @name="business-type-hotel" @size="small" />
            {{this.hotel.hotelinfo.name}}
          {{else if this.market}}
            <PrismIcon @name="business-type-market" @size="small" />
            {{this.market.displayName}}
          {{/if}}</div>
      </EmberTooltip>
    {{/if}}
  </template>
}
